// import React, { useEffect } from "react";
import Logo from '../../Assets/Machcity Logo.png'
import Form from "./Form.jsx";
import Footer from "./Footer.jsx";
import { Link } from 'react-router-dom';

function MachCity() {
  // useEffect(() => {
  //   document.title = "Warranty Registration Form - Machcity"
  // })
  return (
    <section>
      <div className="bg-black w-full">
        {/* Navigation Bar */}
        <nav className="mx-auto max-w-7xl px-4 pt-5 sm:px-6 lg:px-8 flex items-center">
          <div className="flex w-full items-center justify-between">
            {/* Logo */}
            <img
              src={Logo}
              alt="MachCity logo"
              // className="sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-auto lg:h-auto"
            />

            {/* Menu Icon */}
            <div>
              <ul>
                <li>
                  <Link
                    to="/claim"
                    className="text-white font-medium text-sm md:text-base"
                  >
                    Warranty Claim
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Placeholder for Form */}
        <Form />
        {/* <ClaimForm /> */}

        {/* Footer */}
        <Footer />
      </div>
    </section>
  );
}

export default MachCity;
